function initFaqs() {
    const tabs = document.querySelectorAll('.js-tab-faq');
  
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        if (this.classList.contains('active')) {
          this.classList.remove('active');
        } else {
          tabs.forEach(t => t.classList.remove('active'));
          this.classList.add('active');
        }
      });
    });
}
  

initFaqs();
